import withMenu from 'components/common/withMenu'
import GlobalContainer from 'components/layout/globalContainer'
import ProductsAttributesGlobalUpload from 'components/ProductAttributesGlobalUpload/ProductAttributesGlobalUpload'
import { P_PRODUCTS_ATTRIBUTES_GLOBAL_UPLOAD } from 'constants/ConfigProcessNames'
import React, { Component } from 'react'
import { Row } from 'react-bootstrap'
import { WithTranslation, withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'

interface IProductsAttributesGlobalUploadProps extends WithTranslation {
	t: any
}

class ProductsAttributesGlobalUploadContainer extends Component<IProductsAttributesGlobalUploadProps> {
	render() {
		const { t } = this.props

		const containerProps = {
			codeProcess: P_PRODUCTS_ATTRIBUTES_GLOBAL_UPLOAD,
			configTitles: true
		}

		const propsTable = {
			t: t
		}

		return (
			<Row>
				<GlobalContainer {...containerProps}>
					<ProductsAttributesGlobalUpload {...propsTable} />
				</GlobalContainer>
			</Row>
		)
	}
}

export default withTranslation()(
	withMenu(withRouter(ProductsAttributesGlobalUploadContainer))
)
